<template>


	<div class="stage stage--dcpIntro block_dcp" :style="{ 'background-image': backgroundImage }">
		<div class="header__container">
			<div class="header" style="position: relative" v-html="stageData.header"/>
			<div class="text" style="position: relative" v-html="stageData.story"/>
		</div>
		

		<div class="finalization">
			<div class="finalization__tab">
			    <button class="tab__links Persoonlijk active" @click="openTab('Persoonlijk')">{{stageData.your_score_tab}}</button>
			    <!-- <button class="tab__links" onclick="openTab(event, 'Team')">Team</button> -->
			    <button class="tab__links Vergelijk" @click="openTab('Vergelijk')">{{stageData.average_tab}}</button>
			</div>

			<div class="finalization__content active">
				<div id="Persoonlijk" class="tabcontent show">
					<div id="player" style="margin:auto; position: relative; width:80%; height:360px;"/>
					
					<div class="answers">
						<p>{{stageData.show_results_header}}</p>
						<div v-for="(data, index) in dcpData" class="view-questions-link" :class="'view-questions--'+index" @click="setPopup(index)">
							{{typeLabels[index]}}
						</div>
					</div>
					<div class="text" style="position: relative" v-html="dcpText"/>
				</div>

				<!-- <div id="Team" class="tabcontent">
					<img src="images/dcp1.png">
				</div> -->
				<div id="Vergelijk" class="tabcontent">
					<div id="group_dcp" style="margin:auto; position: relative; width:80%; height:360px;"/>

					<div class="text" style="position: relative" v-html="teamDcpText"/>
				</div>


				<br>
				<div class="return-link-holder" v-if="challengeToken">
					<a href="http://onefutureplay.com/my-challenges"><div class="btn btn-progres btn-challenge-return-link">Naar challenges</div></a>
				</div>

			</div>
		</div>




<!-- popup -->
			<div v-if="index == showPopup" v-for="(data, index) in dcpData" class="card card-dcp-popup card-dcp-popup--Kennis active" :class="'card-dcp-popup--'+index">

				<div class="dcp-feedback-container" style="height: auto;">
					<div class="header" style="position: relative" >
						<img :src="baseUrl + '/media/gem_utrecht/Algemeen/dcp_feedback_icon_Kennis.svg'" class="dcp-feedback-icon" /> {{typeLabels[index]}}
					</div>
					<div class="pagingInfo" @click="togglePopup()" style="text-align: right; margin-right: 10px">
						X
					</div>
				</div>
				<div style="height:auto; margin-bottom: 20px;">
					<div class="btn btn-round" @click="()=>{setPopupRound(index)}" v-for="round, index in data.rounds">{{roundLabel}} {{index+1}}</div>
				</div>

				<div class="dcpQuestions">
					<div class="one-time" style="height: 100%;">

						<div v-for="(question , index) in data.rounds[popupRound].questions" class="question">
							<div class="bubbel">
								<p><b>{{questionLabel}} {{index+1}}</b></p>

								<p v-if="typeof question.question !=='undefined'" v-html="question.question"></p>

								<div v-if="typeof question.visual !=='undefined'"><img :src="baseUrl + question.visual"></div>

								<br/>
								<p>{{yourAnswerLabel}}: <span v-html="data.rounds[popupRound].answers[index]"></span></p>

							</div>
							<div class="bubbel">
								<p>{{correctAnswerLabel}}: <span v-html="data.rounds[popupRound].correctAnswers[index]"></span></p>

								<br/>
								<br/>
							</div>
							<div class="bubbel" v-if="typeof question.feedback !== 'undefined'">
								<p>{{question.feedback}}</p>
							</div>



							<!--

							<p>{{feedbackItem.question}}</p>

							<p>Jou antwoord: <span>{{feedbackItem.userAnswer}}</span></p>

							<p>Goede antwoord: <span>{{feedbackItem.correctAnswer}}</span></p>
							<p>{{feedbackItem.correctAnswerText}}</p>


							<p>{{feedbackItem.feedbacktext}}</p>
							-->
						</div>
					</div>


					<button class="slick-prev slick-arrow js-slick-prev" aria-label="Vorige" type="button">{{previousLabel}}</button>
					<button class="slick-next slick-arrow js-slick-next" aria-label="Volgende" type="button">{{nextLabel}}</button>

				</div>

			</div>
		</div>


	</div>

</template>


<script>
	import Vue from 'vue';
	import { mapGetters , mapActions } from 'vuex';
	import { url} from '../../const/base';
	import { api_url} from '../../const/base';
	import { lang } from '../../const/base';
	
	export default {

		data(){
			return{
				baseUrl : url,
				apiUrl : api_url,
				language : lang,
				headerReady: true,
				visualReady: true,
				storyReady: true,
				showPopup: '',
				popupRound: 0,
				dcpText: '',
				teamDcpText: '',
				yesNoLabels: {No:'Nee',Yes:'Ja'},
				typeLabels: {Bewustzijn:'Bewustzijn',Kennis:'Kennis',Skills:'Vaardigheid',Waarden:'Waarden',SDG:'SDG`s'},
				roundLabel: 'Ronde',
				questionLabel: 'Vraag',
				yourAnswerLabel: 'Jouw antwoord',
				correctAnswerLabel: 'Gewenste antwoord',
				nextLabel: 'Volgende',
				previousLabel: 'Vorige',
				sdgClusters:{economy:[8,9,10,12], society:[1,2,3,4,5,7,11,16], biosphere:[6,13,14,15]}
			}
		},

		beforeMount(){
			if(this.language == 'EN'){
				this.typeLabels = {Bewustzijn:'Awareness',Kennis:'Knowledge',Skills:'Skills',Waarden:'Values'},
				this.yesNoLabels = {No:'No',Yes:'Yes'};
				this.roundLabel = 'Round';
				this.questionLabel = 'Question';
				this.nextLabel = 'Next';
				this.previousLabel = 'Previous';
				this.yourAnswerLabel = 'Your answer';
				this.correctAnswerLabel = 'Correct answer';
			}
		},

		mounted(){


			
			this.showTransitorScore(true);
			this.initializeDCP();
			//this.saveAnswerLogs();

			
			// console.log('dcpData');
			// console.log(this.dcpData);

		},

		methods:{
			...mapActions([
				"showNextButton",
				"hideNextButton",
				"setNextButtonAction",
				"toNextStage",
				"stopBlockTransition",
				"showTransitorScore",
				"saveAnswerLogs",
			]),

			setPopup(label){
				this.setPopupRound(0);
				this.showPopup = label;

				this.showTransitorScore(false);
			},
			
			setPopupRound(round){
				this.popupRound = round;
				$('.one-time').slick('unslick');
				setTimeout(()=>{
					$('.one-time').slick({
						dots: false,
						infinite: true,
						speed: 300,
						slidesToShow: 1,
						adaptiveHeight: true,
						arrows: true,
						nextArrow: $('.js-slick-next'),
						prevArrow: $('.js-slick-prev')
					});
				}, 10);

			},

			togglePopup() {
				if(this.showPopup != ''){
					this.showPopup = '';
					setTimeout(()=>{
						$('.one-time').slick({
						  dots: true,
						  infinite: true,
						  speed: 300,
						  slidesToShow: 1,
						  adaptiveHeight: true,
						  arrows: true,
						  nextArrow: $('.js-slick-next'),
						  prevArrow: $('.js-slick-prev')
						});
					}, 10);
					

					this.showTransitorScore(true);
				}
			},

			toDcpObject(data , dataType , renderer , options=null){
				return {
					data : data,
					dataType : dataType,
					renderer : renderer,
					options: options,
				}
			},

			renderer(type, options){
				return {
					type: type,
					options: options,
				}
			},

			initializeDCP(){
				let WW = $('.finalization__content').width()*0.8;
				let WH = WW+60;

				//user DCP
				let player_el = document.getElementById('player');
				let player = bonsai.run(player_el, {
					url: this.baseUrl + 'js/dcp/dcp.js?12',
					height: WW+60,
					width: WW,
					framerate: 50
				});


				//Group DCP
				let group_el = document.getElementById('group_dcp');
				let group = bonsai.run(group_el, {
					url: this.baseUrl + 'js/dcp/dcp.js?12',
					height: WW+60,
					width: WW,
					framerate: 50
				});

				let data = this.dcpData;

				// console.log('dcpData');
				// console.log(data);
				
				//console.log(this.globalSettings.dcp.awareness.label);

				
				let scoresTotal ={}, scores ={};

				for (let property in data)
				{
					if(!scores.hasOwnProperty(property)) scores[property] = [];
					if(!scoresTotal.hasOwnProperty(property)) scoresTotal[property] = 0;
					if (data.hasOwnProperty(property))
					{
						let obj = data[property];
						for (let i = 0; i < obj.rounds.length; i++)
						{
							let round = obj.rounds[i];

							// console.log('round');
							// console.log(round);

							scoresTotal[property] += round.score/obj.rounds.length;
							scores[property].push(round.score);
						}


					}
				}

				console.log('scores for pokeball');

				console.log(scores);

				let centerPiece = 'Waarden';

				if(typeof scores.SDG !== 'undefined'){

					//make average
					let avgWaarden = 0;

					for(let i = 0 ; i < scores.SDG.length ; i++){
						avgWaarden += scores.SDG[i];
					}

					scores.Waarden = [avgWaarden/scores.SDG.length];

					centerPiece = 'SDG';
				}

				let dcpObjectData = {
					data:[
						this.toDcpObject(scores.hasOwnProperty('Bewustzijn') ? scores.Bewustzijn : [] , 'pie-chart' , this.renderer('slice', {
							color: "#6894a0", //Color of data visualization background
							stroke:{ // Can be removed for no stroke drawing
								color : "#fff", //color of stroke around value visualization
								width: 2, // width of stroke around value visualization
							}
						}),
						{
							name: 'Bewustzijn', //Part off the datastream we want to show
							display_name: this.globalSettings.dcp.awareness.label, //Label text
							color: "#8DCBDB" //Background color of pie-chart background
						}),
						this.toDcpObject(scores.hasOwnProperty('Kennis') ? scores.Kennis : [], 'pie-chart' , this.renderer('point', {
							color: "#8d1d1d", //Color of data visualization background
							stroke:{ // Can be removed for no stroke drawing
								color : "#fff", //color of stroke around value visualization
								width: 2, // width of stroke around value visualization
							}
						}),
						{
							name: 'Kennis', //Label text
							display_name: this.globalSettings.dcp.knowledge.label, //Label text
							color: "#bc3030" //Background color of pie-chart background
						}),
						this.toDcpObject(scores.hasOwnProperty('Skills') ? scores.Skills : [] , 'pie-chart' , this.renderer('slice', {
							color: "#629451", //Color of data visualization background
							stroke:{ // Can be removed for no stroke drawing
								color : "#fff", //color of stroke around value visualization
								width: 2, // width of stroke around value visualization
							}
						}),
						{
							name: 'Skills', //Part off the datastream we want to show
							display_name: this.globalSettings.dcp.skills.label, //Label text
							color: "#9bc18e" //Background color of pie-chart background
						}),
						//----------------------------------------- can be stars
						this.toDcpObject(scores.hasOwnProperty('Waarden') ? scores.Waarden : [] , 'center-piece' , this.renderer('stars', {
							color: "#ff9933", // color of background star container
							minRadius : 20, // begin radius of star container
							radiusEdge: 5, // how much edge there will be at score of 100
							fontColor: "#fff",
							fontSize: 14,
							star:{
								color: "#fff", // star color
								size: 7, // star size
								dist: 8, // star distance from center
							},
							stroke:{
								color : "#ff9933", // color of stroke background star container
								width: 0, // width of stroke background star container
							}
						}),
						{
							name: centerPiece, //Part off the datastream we want to show
							display_name: this.globalSettings.dcp.values.label, //Label text
							color: "#ffbf80", //Background color of pie-chart background
							radius: 30, // radius of center-piece container
							stroke:{ // Can be removed for no stroke drawing
								color : "#fff", // color of stroke background center-piece container
								width: 2, // width of stroke background center-piece container
							},
							label:{
								color: "#ff9933", //background color of name label
								width: 110, //width of name label in pixels
								height: 30, // height of name label in pixels
								fontColor: "#fff", //color of label
								fontSize: 14, //fontsize of label
								rounded: 10, //Roundness of background
							}
						})
					],
					options:{
						offset: -45, //angle offset of the pie-chart
						width: WW, //width of canvas
						height: WH, // height of canvas
						radius: WW/2 - 20, //radius of pie
						animate: true,
						animation: {
							delay: 0,// initial delay of the animation
							slice: {
								delay: 15, //delay for each slice
								duration: 10, //duration of slice anim
								data: { 
									initialDelay: 60, //inital delay of the data anim of slice
									delay: 15, //delay for each data value
									duration: 25 //duration of each data value
								}
							}
						},
						text:{
							family: "sans", //font family
						},
						label:{
							score:{
								radius: 14, //radius of score label container
								stroke:{ // Can be removed for no stroke drawing
									color : "#fff", // color of stroke background center-piece container
									width: 2, // width of stroke background center-piece container
								},
								fontSize : 14, //size of text
								fontColor: "#ffffff", //color of text
							},
							name:{
								offset: 15, //how much the background comes outside the pie
								height: 30, //Height of background
								width: 100, //Width of background
								widthPerLetter: 8, //Width per letter (takes over from width if defined)
								fontSize : 14, //Size of text
								fontColor: "#fff", //Color of text
							}
							
						},
						stroke:{
							color: "#fff",
							width: 5
						}
					}
				}


				let self = this;
				player.on('message', function (data) {
					if(data == "ready"){
						player.sendMessage(dcpObjectData);
					}
					else{
						if(self.showPopup == ''){

							self.setPopupRound(0);
							self.showPopup = data;

							self.showTransitorScore(false);
						}
					}
				});

				// {
				// 			awarenessPointsTotal: scoresTotal.hasOwnProperty('Bewustzijn') ? scoresTotal.Bewustzijn : 0,
				// 			awarenessPoints: scores.hasOwnProperty('Bewustzijn') ? scores.Bewustzijn : [],
				// 			awarenessFeedback:"",
				// 			kennisPointsTotal: scoresTotal.hasOwnProperty('Kennis') ? scoresTotal.Kennis : 0,
				// 			kennisPoints: scores.hasOwnProperty('Kennis') ? scores.Kennis : [],
				// 			kennisFeedback: "",
				// 			skillPointsTotal: scoresTotal.hasOwnProperty('Skills') ? scoresTotal.Skills : 0,
				// 			skillPoints: scores.hasOwnProperty('Skills') ? scores.Skills : [0,0],
				// 			skillFeedback: "",
				// 			waardenPointsTotal: scoresTotal.hasOwnProperty('Waarden') ? scoresTotal.Waarden : 0,
				// 			waardenPoints: scores.hasOwnProperty('Waarden') ? scores.Waarden : [],
				// 			waardenFeedback: "",
				// 			mbti: self.mbtiProfile,
				// 			ww: WW,
				// 			wh: WH
				// 		}



				// console.log('userRole');
				// console.log(this.userRole);

				// console.log('mbtiProfile');
				// console.log(this.mbtiProfile.trueColorClassification[2]);


				//build dcp profile text
				const dcpTextObj = this.dcpProfileText;
				let parts = '';
				for(var key in dcpTextObj) {

					let myText = '';

					if(typeof dcpTextObj[key][0] !== 'undefined'){
						myText = dcpTextObj[key][0].text;
					}

					//loop over dcp part text to find the right one
					for (let i = 0; i < dcpTextObj[key].length; i++){
						
						// console.log('scoresTotal');
						// console.log(scoresTotal[key]);

						if(scoresTotal[key] >= dcpTextObj[key][i].breakpoint){
							myText = dcpTextObj[key][i].text;
						}
					}
					parts += myText+' ';
				}

				this.dcpText = parts;

				// console.log('dcp profile text');
				// console.log(this.dcpText);

				let sendObj = {
					"user_id": this.userId,
					"instance_id" : this.instanceId,
					"pointsjson" : scores,
					"transitorScore" : this.transitorScore,
					"role": this.userRole,
					"mbti": this.mbtiProfile,
					"challenges_session_token": this.challengeToken,
					"dcp_profile_text": this.dcpText
				};

				
				// console.log('challengeToken: '+this.challengeToken);

				if(this.challengeToken){
					this.$socket.emit('finished challenge', sendObj);
				}
				
				Vue.http.post(this.apiUrl + '/api/v2/savescore' , sendObj).then(response => {
					//console.log(response.status);
					//console.log("lol");
					//console.log(response.statusText);
					//console.log(response.body);


					const avgScores = response.body.points.dcp;
					const avgScoresTotal = response.body.points.avg;


					// console.log('group dcp data');
					// console.log(avgScores);

					let groupdcpObjectData = {
						data:[
							this.toDcpObject(avgScores.hasOwnProperty('Bewustzijn') ? avgScores.Bewustzijn : [] , 'pie-chart' , this.renderer('slice', {
								color: "#6894a0", //Color of data visualization background
								stroke:{ // Can be removed for no stroke drawing
									color : "#fff", //color of stroke around value visualization
									width: 2, // width of stroke around value visualization
								}
							}),
							{
								name: "Bewustzijn", //Part text
								display_name: "Bewustzijn", //Label text
								color: "#8DCBDB" //Background color of pie-chart background
							}),
							this.toDcpObject(avgScores.hasOwnProperty('Kennis') ? avgScores.Kennis : [], 'pie-chart' , this.renderer('point', {
								color: "#8d1d1d", //Color of data visualization background
								stroke:{ // Can be removed for no stroke drawing
									color : "#fff", //color of stroke around value visualization
									width: 2, // width of stroke around value visualization
								}
							}),
							{
								name: "Kennis", //Part text
								display_name: "Kennis", //Label text
								color: "#bc3030" //Background color of pie-chart background
							}),
							this.toDcpObject(avgScores.hasOwnProperty('Skills') ? avgScores.Skills : [] , 'pie-chart' , this.renderer('slice', {
								color: "#629451", //Color of data visualization background
								stroke:{ // Can be removed for no stroke drawing
									color : "#fff", //color of stroke around value visualization
									width: 2, // width of stroke around value visualization
								}
							}),
							{
								name: "Skills", //Part text
								display_name: "Vaardigheid", //Label text
								color: "#9bc18e" //Background color of pie-chart background
							}),
							//----------------------------------------- can be stars
							this.toDcpObject(avgScores.hasOwnProperty('Waarden') ? avgScores.Waarden : [] , 'center-piece' , this.renderer('stars', {
								color: "#ff9933", // color of background star container
								minRadius : 20, // begin radius of star container
								radiusEdge: 5, // how much edge there will be at score of 100
								fontColor: "#fff",
								fontSize: 14,
								star:{
									color: "#fff", // star color
									size: 7, // star size
									dist: 8, // star distance from center
								},
								stroke:{
									color : "#ff9933", // color of stroke background star container
									width: 0, // width of stroke background star container
								}
							}),
							{
								name: "Waarden", //Label text
								display_name: "Waarden", //Label text
								color: "#ffbf80", //Background color of pie-chart background
								radius: 30, // radius of center-piece container
								stroke:{ // Can be removed for no stroke drawing
									color : "#fff", // color of stroke background center-piece container
									width: 2, // width of stroke background center-piece container
								},
								label:{
									color: "#ff9933", //background color of name label
									width: 110, //width of name label in pixels
									height: 30, // height of name label in pixels
									fontColor: "#fff", //color of label
									fontSize: 14, //fontsize of label
									rounded: 10, //Roundness of background
								}
							})
						],
						options:{
							offset: -45, //angle offset of the pie-chart
							width: WW, //width of canvas
							height: WH, // height of canvas
							radius: WW/2 - 20, //radius of pie
							animate: true,
							animation: {
								delay: 0,// initial delay of the animation
								slice: {
									delay: 15, //delay for each slice
									duration: 10, //duration of slice anim
									data: { 
										initialDelay: 60, //inital delay of the data anim of slice
										delay: 15, //delay for each data value
										duration: 25 //duration of each data value
									}
								}
							},
							text:{
								family: "sans", //font family
							},
							label:{
								score:{
									radius: 14, //radius of score label container
									stroke:{ // Can be removed for no stroke drawing
										color : "#fff", // color of stroke background center-piece container
										width: 2, // width of stroke background center-piece container
									},
									fontSize : 14, //size of text
									fontColor: "#ffffff", //color of text
								},
								name:{
									offset: 15, //how much the background comes outside the pie
									height: 30, //Height of background
									width: 100, //Width of background
									widthPerLetter: 8, //Width per letter (takes over from width if defined)
									fontSize : 14, //Size of text
									fontColor: "#fff", //Color of text
								}
								
							},
							stroke:{
								color: "#fff",
								width: 5
							}
						}
					};


					group.sendMessage(groupdcpObjectData);

					// {
					// 	awarenessPointsTotal: avgScoresTotal.hasOwnProperty('Bewustzijn') ? avgScoresTotal.Bewustzijn : 0,
					// 	awarenessPoints: avgScores.hasOwnProperty('Bewustzijn') ? avgScores.Bewustzijn : [],
					// 	awarenessFeedback:"",
					// 	kennisPointsTotal: avgScoresTotal.hasOwnProperty('Kennis') ? avgScoresTotal.Kennis : 0,
					// 	kennisPoints: avgScores.hasOwnProperty('Kennis') ? avgScores.Kennis : [],
					// 	kennisFeedback: "",
					// 	skillPointsTotal: avgScoresTotal.hasOwnProperty('Skills') ? avgScoresTotal.Skills : 0,
					// 	skillPoints: avgScores.hasOwnProperty('Skills') ? avgScores.Skills : [0,0],
					// 	skillFeedback: "",
					// 	waardenPointsTotal: avgScoresTotal.hasOwnProperty('Waarden') ? avgScoresTotal.Waarden : 0,
					// 	waardenPoints: avgScores.hasOwnProperty('Waarden') ? avgScores.Waarden : [],
					// 	waardenFeedback: "",
					// 	ww: WW,
					// 	wh: WH
					// }



					const dcpTextObj = this.dcpProfileText;
					// let parts = '';
					// for(var key in dcpTextObj) {

					// 	let myText = dcpTextObj[key][0].text;
					// 	//loop over dcp part text to find the right one
					// 	for (let i = 0; i < dcpTextObj[key].length; i++){
							

					// 		//console.log(scoresTotal[key]);

					// 		if(scoresTotal[key] >= dcpTextObj[key][i].breakpoint){
					// 			myText = dcpTextObj[key][i].text;
					// 		}
					// 	}
					// 	parts += myText+' ';
					// }

					// this.dcpText = parts;

					// console.log('dcp profile text');

					// console.log(this.dcpText);


					let teamParts = '';
					for(var key in dcpTextObj) {

						//console.log(key);

						let myText = '';

						if(typeof dcpTextObj[key][0] !== 'undefined'){
							myText = dcpTextObj[key][0].text;
						}

						//loop over dcp part text to find the right one
						for (let i = 0; i < dcpTextObj[key].length; i++){
							

							// console.log(avgScoresTotal[key]);

							if(avgScoresTotal[key] >= dcpTextObj[key][i].breakpoint){
								myText = dcpTextObj[key][i].text;
							}
						}
						// console.log(myText);
						teamParts += myText+' ';
					}


					this.teamDcpText = teamParts;


				}).catch(response => {
					//console.log("Error: ");
					//console.log(response);
				});



			},
			
			openTab(cityName) {
			    var i, tabcontent, tablinks;
			    tabcontent = document.getElementsByClassName("tabcontent");
			    for (i = 0; i < tabcontent.length; i++) {
			        tabcontent[i].style.display = "none";
			    }
			    tablinks = document.getElementsByClassName("tab__links");
			    for (i = 0; i < tablinks.length; i++) {
			        tablinks[i].className = tablinks[i].className.replace(" active", "");
			    }
			    document.getElementById(cityName).style.display = "block";
			    //evt.currentTarget.className += " active";
			    $('.'+cityName).addClass('active');

			}

		},

		computed: {

			sdgData(){

				console.log('compute sdgData');

				let sdgObject = {};

				sdgObject.sdgCount = {};

				for(let i = 0 ; i < this.blocks.length ; i++){
					let block = this.blocks[i];


					if(block.settings == null || typeof block.settings.score === 'undefined') continue;
					else if(block.settings.score.use != "Yes") continue;


					for(let j = 0 ; j < block.data_structure.length ; j++){
						let stage = block.data_structure[j];
						if(stage.type != 'Rounds') continue;

						for(let k = 0 ; k < stage.data.rounds.length ; k++){

							let roundData = {questions:[]};
							let round = stage.data.rounds[k];

							console.log('round');
							console.log(round);


							if(round.questions.usescore != "Yes") continue;

							//combine all found sdg's to an array as key => count
							if(typeof round.sdgs !== 'undefined'){

								for (var l = 0; l < round.sdgs.length; l++) {
									
									let sdgIndex = round.sdgs[l];

									if(typeof sdgObject.sdgCount[sdgIndex] === 'undefined'){

										sdgObject.sdgCount[sdgIndex] = 1;

									}else{
										sdgObject.sdgCount[sdgIndex] += 1;
									}

								}

							}

						}

					}

				}

				//sdgClusters
				sdgObject.clusters = {};
				for (let property in this.sdgClusters)
				{
					if (this.sdgClusters.hasOwnProperty(property)){

						let cluster = this.sdgClusters[property];
						let clusterCount = 0;

						for(let j = 0 ; j < cluster.length; j++){
							if(sdgObject.sdgCount[cluster[j]] > 0){
								clusterCount += sdgObject.sdgCount[cluster[j]];
							}
						}

						sdgObject.clusters[property] = clusterCount;
					}

				};

				return sdgObject;

			},

			dcpData(){

				console.log('compute dcpData');

				let dcpData = {};
				for(let i = 0 ; i < this.blocks.length ; i++){
					let block = this.blocks[i];


					if(block.settings == null || typeof block.settings.score === 'undefined') continue;
					else if(block.settings.score.use != "Yes") continue;

					if(!dcpData.hasOwnProperty(block.settings.score.label)){
						dcpData[block.settings.score.label] = {rounds:[]}
					}
					
					//label
					//displaylabel

					console.log(block.settings.score.label);

					let blockData = dcpData[block.settings.score.label];

					for(let j = 0 ; j < block.data_structure.length ; j++){
						let stage = block.data_structure[j];
						if(stage.type != 'Rounds') continue;
						for(let k = 0 ; k < stage.data.rounds.length ; k++){

							let roundData = {questions:[]};
							let round = stage.data.rounds[k];

							// console.log('round');
							// console.log(round);


							if(round.questions.usescore != "Yes") continue;



							roundData.score = round.score == undefined ? 0 : round.score;
							if(round.gametype == "worldquiz") roundData.answers = round.answers == undefined ? [] : [round.answers];
							else roundData.answers = round.answers == undefined ? [] : round.answers;
							roundData.correctAnswers = [];
							roundData.type = round.gametype;

							for(let l = 0 ; l < round.questions.questions.length ; l++){
								let question = round.questions.questions[l];
								let questionData ={};

								switch(round.gametype){
									case "worldquiz":
										questionData.question = round.questions.intro_explanation;
										let answerHtml = '';

										for(let answerIndex = 0 ; answerIndex < question.items.length ; answerIndex++){

											answerHtml += '<div class="worldquiz-dcp-feedback-item">'+question.items[answerIndex].name + ': ' + (question.items[answerIndex].amount*10) + '%</div>'
										}
										

										roundData.correctAnswers.push(answerHtml);
										break;
									case "systeemdenken":
										questionData.question = question.questiontext;

										let answerHtmlLandmark = '';

										for(let answerIndex = 0 ; answerIndex < question.answers.length ; answerIndex++){


											//console.log(question.items[question.answers[answerIndex].from-1].name + ' naar ' + question.items[question.answers[answerIndex].to-1].name);

											answerHtmlLandmark += '<div class="systeemdenken-dcp-feedback-item">Van '+question.items[question.answers[answerIndex].from-1].name + ' naar ' + question.items[question.answers[answerIndex].to-1].name + '</div>'
										}
										

										roundData.correctAnswers.push(answerHtmlLandmark);
										break;
									case "systeemdenken_controlevragen":
										questionData.question = question.questiontext;
										roundData.correctAnswers.push(question.answers[question.correct_answer-1].answer);
										break;

									case "matchingquiz":
										questionData.question = '';

										questionData.visual = question.visual;

										//console.log(question);

										roundData.correctAnswers.push(question.answers[question.correct_answer-1].answer_text);

										break;
									case "simonsays":
										questionData.question = question.questiontext;

										
										let correctAnswersArray = question.correct_answers.split(',');

										let ssAnswerHtml = '<br>';
										for(let answerIndex = 0 ; answerIndex < correctAnswersArray.length ; answerIndex++){


											//console.log(question.answers[parseInt(correctAnswersArray[answerIndex])-1].label);

											if(typeof question.answers[parseInt(correctAnswersArray[answerIndex])-1] !== 'undefined'){

												ssAnswerHtml += question.answers[parseInt(correctAnswersArray[answerIndex])-1].label+'<br>';
											}

										}

										roundData.correctAnswers.push(ssAnswerHtml);

										break;
									case "swipequiz":

										questionData.question = question.caption;
										roundData.correctAnswers.push(this.yesNoLabels[question.answer]);
										break;
									case "abquiz":
										questionData.question = question.questiontext;
										roundData.correctAnswers.push(question.answers[question.correct_answer-1].answer_text);
										//roundData.correctAnswers.push(question.correct_answer);
										break;
								}
								questionData.feedback = question.feedbacktext;
								roundData.questions.push(questionData);
							}

							if(typeof roundData.answers !== "undefined"){
								//build labels for user answers
								for(let l = 0 ; l < round.questions.questions.length ; l++){
									let question = round.questions.questions[l];


									if(typeof roundData.answers[l] !== "undefined"){

										switch(round.gametype){
											case "worldquiz":
												let answerHtml = '';
												for(let answerIndex = 0 ; answerIndex < roundData.answers[l].length ; answerIndex++){
													answerHtml += '<div class="worldquiz-dcp-feedback-item">'+question.items[answerIndex].name + ': ' + (roundData.answers[l][answerIndex]*10) + '%</div>'
												}
												roundData.answers[l] = answerHtml;
												break;

											case "systeemdenken":

												// console.log('systeemdenken');
												// console.log(roundData);

												let answerHtmlLandmark = '';
												
												for(let answerIndex = 0 ; answerIndex < roundData.answers[l].length ; answerIndex++){

													if(typeof roundData.answers[l][answerIndex].from !== 'undefined'){
														answerHtmlLandmark += '<div class="systeemdenken-dcp-feedback-item">Van '+question.items[roundData.answers[l][answerIndex].from].name + ' naar ' + question.items[roundData.answers[l][answerIndex].to].name + '</div>'
													}
												}
												

												roundData.answers[l] = answerHtmlLandmark;
												break;
											case "systeemdenken_controlevragen":

												if(typeof question.answers[roundData.answers[l]] !== "undefined"){
													roundData.answers[l] = question.answers[roundData.answers[l]].answer;
												}
												break;
											case "swipequiz":
												roundData.answers[l] = this.yesNoLabels[roundData.answers[l]];
												break;

											case "simonsays":

												let ssAnswerHtml = '<br>';
												for(let answerIndex = 0 ; answerIndex < roundData.answers[l].length ; answerIndex++){

													ssAnswerHtml += question.answers[roundData.answers[l][answerIndex]].label+'<br>';

												}

												roundData.answers[l] = ssAnswerHtml;
												break;

											case "abquiz":

												if(typeof question.answers[roundData.answers[l]-1] !== "undefined"){
													roundData.answers[l] = question.answers[roundData.answers[l]-1].answer_text;
												}
												break;
											case "matchingquiz":

												if(typeof question.answers[roundData.answers[l]] !== "undefined"){
													roundData.answers[l] = question.answers[roundData.answers[l]].answer_text;
												}
												break;
										}
									
									}
								}
							}

							blockData.rounds.push(roundData);
						}
					}
				}
				return dcpData;
			},

			...mapGetters([
				"globalSettings",
				"stageData",
				"lastStage",
				"blocks",
				"lastBlock",
				"transitorScore",
				"answerLogs",
				"instanceId",
				"userId",
				"userRole",
				"mbtiProfile",
				"challengeToken",
				"dcpProfileText"
			]),

			
			backgroundImage: function() {
				if(typeof this.stageData.background === 'undefined'){ 
					return 'none'
				}
		        return 'url('+ this.baseUrl + this.stageData.background + ')';
		    },
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/dcp/Dcp.vue